import { FormState, FieldState } from '../../../../../mainv2/states/FormState';
import { NewPassword } from '../../../../types/user_info';

export class PasswordChangeFormState extends FormState<NewPassword> {
    constructor() {
        super({
            current_password: new FieldState('', false),
            password: new FieldState('', false),
            password_confirmation: new FieldState('', false),
        });
    }
}
